import React from 'react';
import { GiftCardStatusTag } from '../../../../components/GiftCardStatusTag/GiftCardStatusTag';
import { GiftCardTableCell } from '../GiftCardTableCell/GiftCardTableCell';
import { GiftCardUsageTableCell } from '../GiftCardUsageTableCell/GiftCardUsageTableCell';
import * as S from './GiftCardListItem.styled';
export const GiftCardListItem = ({ giftCard }) => {
    return (React.createElement(S.Container, null,
        React.createElement(GiftCardTableCell, { giftCard: giftCard }),
        React.createElement(GiftCardStatusTag, { status: giftCard.status }),
        React.createElement(S.UsageWrapper, null,
            React.createElement(GiftCardUsageTableCell, { giftCard: giftCard }))));
};
